var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 15.834,
    viewBox: "0 0 12.5 15.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "description_FILL0_wght300_GRAD0_opsz20_1_",
    "data-name": "description_FILL0_wght300_GRAD0_opsz20 (1)",
    d: "M6.875,14.833h6.25V13.5H6.875Zm0-3.291h6.25V10.208H6.875ZM5.333,17.917A1.566,1.566,0,0,1,3.75,16.333V3.667A1.566,1.566,0,0,1,5.333,2.083h6.459L16.25,6.542v9.791a1.566,1.566,0,0,1-1.583,1.584ZM11.125,7.208V3.417H5.333a.3.3,0,0,0-.25.25V16.333a.3.3,0,0,0,.25.25h9.334a.3.3,0,0,0,.25-.25V7.208ZM5.083,3.417v0Z",
    transform: "translate(-3.75 -2.083)",
    fill: "#3b76f7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewNoteIcon);
export default __webpack_public_path__ + "static/media/view-note-icon.8131c70132d568f56a160db687ca5712.svg";
export { ForwardRef as ReactComponent };